define("shared/components/shared/pre-boarding/auto-trial-end/index", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "tracked-built-ins", "later/utils/constants"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _trackedBuiltIns, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"tracked-built-ins",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{false}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{false}} class="tPF--modalCard">
      <modal.card-header class="u--p__b__sm">
        <h2 class="o--modalHeader__title u--text--center u--text--lg u--m__b__xs">
          {{t "plans.auto_trial.end_trial.title"}}
        </h2>
        <p class="u--text--center u--text--sm">
          {{t "plans.auto_trial.end_trial.subtitle"}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <section class="tPF--planWrapper">
          <div class="tPF--plan tPF--plan—-sm u--m__t__0">
            {{#if (user-agent "device.isMobile")}}
              <div class="tPF--plan tPF--plan—-sm u--m__b__0">
                {{#each this.allPlans as |plan|}}
                  <Shared::Upgrade::MobilePlanCard
                    @plan={{plan}}
                    @selectPlan={{this.selectPlan}}
                    @selectedPlan={{this.selectedPlanType}}
                    @showBonusFeatures={{false}}
                  />
                {{/each}}
              </div>
            {{else}}
              {{#each this.allPlans as |plan|}}
                <div
                  class="tPF--plan__item
                    {{concat 'tPF--plan__item--' plan.planType}}
                    {{if @isCurrentPlan 'tPF--plan__item--current'}}
                    "
                >
                  {{#if (eq plan.planType @trialedPlan.planType)}}
                    <div class="tPF--plan__hl tPF--plan__hl--white">
                      {{t "plans.auto_trial.end_trial.you_tried_this_plan"}}
                    </div>
                  {{/if}}
                  <div class="tPF--plan__upper">
                    {{! Title }}
                    <h2 class="tPF--plan__title qa--plan__title {{concat 'tPF--plan__title--' plan.planType}}">
                      {{plan.name}}
                    </h2>
                    {{! Sub title }}
                    <p class="tPF--plan__subTitle qa--plan__subtitle">
                      {{t (concat "authorization.sign_up_trial." plan.planType ".description")}}
                    </p>
                  </div>
                  {{! Price Title }}
                  <span
                    class="tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs u--text--hair qa--price_starting_point_text"
                  >
                    {{t "plans.from"}}
                  </span>
                  {{! Price }}
                  <div class="tPF--plan__price">
                    <sup class="tPF--plan__priceCurrency">{{t "plans.currency_symbol"}}</sup>
                    <span class="tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price">
                      {{div plan.monthlyPrice 100}}
                    </span>
                    <span class="tPF--plan__priceDuration">{{t "plans.auto_trial.end_trial.per_month"}}</span>
                  </div>
                  {{! Highlights / Includes }}
                  <div class="tPF--plan__meta">
                    <h5 class="tPF--plan__metaTitle tPF--plan__metaTitle--color">{{t "plans.card.includes"}}</h5>
                    <p class="tCK--plan__metaRow u--text--sm">
                      <span class="u--text--bold">
                        {{t "plans.card.social_set" count=plan.socialSets}}
                      </span>
                      <span class="tPF--social__set u--text--sm u--m__l__xs u--text--hair">
                        <span>{{t "plans.card.includes_social_open_bracket"}}</span>
                        <span>{{t "plans.card.includes_social_set" count=plan.socialSets}}</span>
                        <Shared::SocialSetIcons />
                        <span>{{t "plans.card.includes_social_close_bracket"}}</span>
                      </span>
                    </p>
                    <p class="tCK--plan__metaRow u--text--sm">
                      <span clas="u--text--bold">{{t "plans.card.team_members" count=plan.users}}</span>
                      <span class="u--m__l__xs">
                        {{svg-jar "overview" class="o--icon--sm tPF--plan__icon u--text--light"}}
                      </span>
                    </p>
                  </div>
                  {{! Key Features }}
                  <div class="tPF--plan__meta u--m__tb__sm tPF--plan__meta--lg">
                    <h5 class="tPF--plan__metaTitle u--text--sm u--m__t__0">{{t "plans.key_features"}}</h5>
                    {{#each plan.autoTrialHighlights.keyFeatures as |feature|}}
                      <p class="tPF--plan__metaRow u--text--sm u--m__b__xs u--text--hair">
                        {{svg-jar "check" class="o--icon--sm tPF--plan__icon"}}
                        <span>{{feature}}</span>
                      </p>
                    {{/each}}
                    {{! You'll lose access to }}
                    {{#if plan.autoTrialHighlights.loseAccess}}
                      <h5 class="tPF--plan__metaTitle u--text--sm u--m__t__md">
                        {{t "plans.auto_trial.end_trial.lose_access"}}
                      </h5>
                      {{#each plan.autoTrialHighlights.loseAccess as |loss|}}
                        <p class="tPF--plan__metaRow u--text--sm u--m__b__xs u--text--hair">
                          {{svg-jar "delete-circle" class="o--icon--sm tPF--plan__icon u--text--warning"}}
                          <span> {{loss}}</span>
                        </p>
                      {{/each}}
                    {{/if}}
                  </div>
                  {{#if (not-eq plan.planType "free")}}
                    <div class="tPF--plan__meta">
                      <div class="tPF--plan__metaCol u--m__0">
                        <div class="tPF--plan__metaRow">
                          <Shared::Ui::Button
                            @onClick={{fn this.toggleAllFeaturesModal plan.planType}}
                            @variant="unstyled"
                            class="tPF--plan__link u--p__0"
                          >
                            {{svg-jar "info" class="o--icon tPF--plan__icon"}}
                            {{t "authorization.sign_up_trial.plan_details_link" planName=plan.name}}
                          </Shared::Ui::Button>
                        </div>
                      </div>
                    </div>
                  {{/if}}
                  <Shared::Ui::Button
                    @additional="block"
                    @onClick={{perform this.handleClick plan.planType}}
                    @size="large"
                    @variant="outline"
                    class={{concat-classes (if (not-eq plan.planType "free") "tPF--plan__btn") " u--m__t__xs"}}
                    data-test-id="button"
                  >
                    {{t (concat "plans.auto_trial.end_trial.plans." plan.planType ".cta_button")}}
                  </Shared::Ui::Button>
                </div>
              {{/each}}
            {{/if}}
            {{#if (user-agent "device.isMobile")}}
              <Shared::Ui::Button
                @additional="block"
                @isDisabled={{not this.selectedPlanType}}
                @size="large"
                @text={{t "shared_words.continue"}}
                @variant="primary"
                class="tPF--plan__btn u--text--lg u--m__t__lg {{if this.selectedPlanType this.startTrialButtonClass}}"
                {{on "click" (perform this.handleClick this.selectedPlanType)}}
              />
  
              <Shared::Ui::Button
                @additional="block"
                @onClick={{perform this.handleClick "free"}}
                @size="large"
                @text={{t "plans.auto_trial.end_trial.stay_on_free"}}
                @variant="mute"
              />
            {{/if}}
          </div>
        </section>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  {{#if this.showAllFeaturesModal}}
    <Shared::Upgrade::AllFeaturesModal
      @close={{this.toggleAllFeaturesModal}}
      @focusTrap={{true}}
      @isMonthly={{true}}
      @planType={{this.selectedPlanType}}
    />
  {{/if}}
  */
  {
    "id": "Q7QGs/Er",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@focusTrap\"],[false,true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"tPF--modalCard\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--text--center u--text--lg u--m__b__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.auto_trial.end_trial.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--center u--text--sm\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.auto_trial.end_trial.subtitle\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"section\"],[14,0,\"tPF--planWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm u--m__t__0\"],[12],[1,\"\\n\"],[41,[28,[37,3],[\"device.isMobile\"],null],[[[1,\"            \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm u--m__b__0\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"allPlans\"]]],null]],null],null,[[[1,\"                \"],[8,[39,6],null,[[\"@plan\",\"@selectPlan\",\"@selectedPlan\",\"@showBonusFeatures\"],[[30,2],[30,0,[\"selectPlan\"]],[30,0,[\"selectedPlanType\"]],false]],null],[1,\"\\n\"]],[2]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],[[[42,[28,[37,5],[[28,[37,5],[[30,0,[\"allPlans\"]]],null]],null],null,[[[1,\"              \"],[10,0],[15,0,[29,[\"tPF--plan__item\\n                  \",[28,[37,7],[\"tPF--plan__item--\",[30,3,[\"planType\"]]],null],\"\\n                  \",[52,[30,4],\"tPF--plan__item--current\"],\"\\n                  \"]]],[12],[1,\"\\n\"],[41,[28,[37,8],[[30,3,[\"planType\"]],[30,5,[\"planType\"]]],null],[[[1,\"                  \"],[10,0],[14,0,\"tPF--plan__hl tPF--plan__hl--white\"],[12],[1,\"\\n                    \"],[1,[28,[35,1],[\"plans.auto_trial.end_trial.you_tried_this_plan\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[10,0],[14,0,\"tPF--plan__upper\"],[12],[1,\"\\n\"],[1,\"                  \"],[10,\"h2\"],[15,0,[29,[\"tPF--plan__title qa--plan__title \",[28,[37,7],[\"tPF--plan__title--\",[30,3,[\"planType\"]]],null]]]],[12],[1,\"\\n                    \"],[1,[30,3,[\"name\"]]],[1,\"\\n                  \"],[13],[1,\"\\n\"],[1,\"                  \"],[10,2],[14,0,\"tPF--plan__subTitle qa--plan__subtitle\"],[12],[1,\"\\n                    \"],[1,[28,[35,1],[[28,[37,7],[\"authorization.sign_up_trial.\",[30,3,[\"planType\"]],\".description\"],null]],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"],[1,\"                \"],[10,1],[14,0,\"tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs u--text--hair qa--price_starting_point_text\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"plans.from\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"],[1,\"                \"],[10,0],[14,0,\"tPF--plan__price\"],[12],[1,\"\\n                  \"],[10,\"sup\"],[14,0,\"tPF--plan__priceCurrency\"],[12],[1,[28,[35,1],[\"plans.currency_symbol\"],null]],[13],[1,\"\\n                  \"],[10,1],[14,0,\"tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price\"],[12],[1,\"\\n                    \"],[1,[28,[35,9],[[30,3,[\"monthlyPrice\"]],100],null]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,1],[14,0,\"tPF--plan__priceDuration\"],[12],[1,[28,[35,1],[\"plans.auto_trial.end_trial.per_month\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n\"],[1,\"                \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n                  \"],[10,\"h5\"],[14,0,\"tPF--plan__metaTitle tPF--plan__metaTitle--color\"],[12],[1,[28,[35,1],[\"plans.card.includes\"],null]],[13],[1,\"\\n                  \"],[10,2],[14,0,\"tCK--plan__metaRow u--text--sm\"],[12],[1,\"\\n                    \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n                      \"],[1,[28,[35,1],[\"plans.card.social_set\"],[[\"count\"],[[30,3,[\"socialSets\"]]]]]],[1,\"\\n                    \"],[13],[1,\"\\n                    \"],[10,1],[14,0,\"tPF--social__set u--text--sm u--m__l__xs u--text--hair\"],[12],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,1],[\"plans.card.includes_social_open_bracket\"],null]],[13],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,1],[\"plans.card.includes_social_set\"],[[\"count\"],[[30,3,[\"socialSets\"]]]]]],[13],[1,\"\\n                      \"],[8,[39,10],null,null,null],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,1],[\"plans.card.includes_social_close_bracket\"],null]],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,2],[14,0,\"tCK--plan__metaRow u--text--sm\"],[12],[1,\"\\n                    \"],[10,1],[14,\"clas\",\"u--text--bold\"],[12],[1,[28,[35,1],[\"plans.card.team_members\"],[[\"count\"],[[30,3,[\"users\"]]]]]],[13],[1,\"\\n                    \"],[10,1],[14,0,\"u--m__l__xs\"],[12],[1,\"\\n                      \"],[1,[28,[35,11],[\"overview\"],[[\"class\"],[\"o--icon--sm tPF--plan__icon u--text--light\"]]]],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"],[1,\"                \"],[10,0],[14,0,\"tPF--plan__meta u--m__tb__sm tPF--plan__meta--lg\"],[12],[1,\"\\n                  \"],[10,\"h5\"],[14,0,\"tPF--plan__metaTitle u--text--sm u--m__t__0\"],[12],[1,[28,[35,1],[\"plans.key_features\"],null]],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,3,[\"autoTrialHighlights\",\"keyFeatures\"]]],null]],null],null,[[[1,\"                    \"],[10,2],[14,0,\"tPF--plan__metaRow u--text--sm u--m__b__xs u--text--hair\"],[12],[1,\"\\n                      \"],[1,[28,[35,11],[\"check\"],[[\"class\"],[\"o--icon--sm tPF--plan__icon\"]]]],[1,\"\\n                      \"],[10,1],[12],[1,[30,6]],[13],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[6]],null],[41,[30,3,[\"autoTrialHighlights\",\"loseAccess\"]],[[[1,\"                    \"],[10,\"h5\"],[14,0,\"tPF--plan__metaTitle u--text--sm u--m__t__md\"],[12],[1,\"\\n                      \"],[1,[28,[35,1],[\"plans.auto_trial.end_trial.lose_access\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,3,[\"autoTrialHighlights\",\"loseAccess\"]]],null]],null],null,[[[1,\"                      \"],[10,2],[14,0,\"tPF--plan__metaRow u--text--sm u--m__b__xs u--text--hair\"],[12],[1,\"\\n                        \"],[1,[28,[35,11],[\"delete-circle\"],[[\"class\"],[\"o--icon--sm tPF--plan__icon u--text--warning\"]]]],[1,\"\\n                        \"],[10,1],[12],[1,\" \"],[1,[30,7]],[13],[1,\"\\n                      \"],[13],[1,\"\\n\"]],[7]],null]],[]],null],[1,\"                \"],[13],[1,\"\\n\"],[41,[28,[37,12],[[30,3,[\"planType\"]],\"free\"],null],[[[1,\"                  \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"tPF--plan__metaCol u--m__0\"],[12],[1,\"\\n                      \"],[10,0],[14,0,\"tPF--plan__metaRow\"],[12],[1,\"\\n                        \"],[8,[39,13],[[24,0,\"tPF--plan__link u--p__0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,14],[[30,0,[\"toggleAllFeaturesModal\"]],[30,3,[\"planType\"]]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                          \"],[1,[28,[35,11],[\"info\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n                          \"],[1,[28,[35,1],[\"authorization.sign_up_trial.plan_details_link\"],[[\"planName\"],[[30,3,[\"name\"]]]]]],[1,\"\\n                        \"]],[]]]]],[1,\"\\n                      \"],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[8,[39,13],[[16,0,[28,[37,15],[[52,[28,[37,12],[[30,3,[\"planType\"]],\"free\"],null],\"tPF--plan__btn\"],\" u--m__t__xs\"],null]],[24,\"data-test-id\",\"button\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,16],[[30,0,[\"handleClick\"]],[30,3,[\"planType\"]]],null],\"large\",\"outline\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,1],[[28,[37,7],[\"plans.auto_trial.end_trial.plans.\",[30,3,[\"planType\"]],\".cta_button\"],null]],null]],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[3]],null]],[]]],[41,[28,[37,3],[\"device.isMobile\"],null],[[[1,\"            \"],[8,[39,13],[[16,0,[29,[\"tPF--plan__btn u--text--lg u--m__t__lg \",[52,[30,0,[\"selectedPlanType\"]],[30,0,[\"startTrialButtonClass\"]]]]]],[4,[38,18],[\"click\",[28,[37,16],[[30,0,[\"handleClick\"]],[30,0,[\"selectedPlanType\"]]],null]],null]],[[\"@additional\",\"@isDisabled\",\"@size\",\"@text\",\"@variant\"],[\"block\",[28,[37,17],[[30,0,[\"selectedPlanType\"]]],null],\"large\",[28,[37,1],[\"shared_words.continue\"],null],\"primary\"]],null],[1,\"\\n\\n            \"],[8,[39,13],null,[[\"@additional\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[28,[37,16],[[30,0,[\"handleClick\"]],\"free\"],null],\"large\",[28,[37,1],[\"plans.auto_trial.end_trial.stay_on_free\"],null],\"mute\"]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,19],null,[[\"@close\",\"@focusTrap\",\"@isMonthly\",\"@planType\"],[[30,0,[\"toggleAllFeaturesModal\"]],true,true,[30,0,[\"selectedPlanType\"]]]],null],[1,\"\\n\"]],[]],null]],[\"modal\",\"plan\",\"plan\",\"@isCurrentPlan\",\"@trialedPlan\",\"feature\",\"loss\"],false,[\"shared/modal\",\"t\",\"if\",\"user-agent\",\"each\",\"-track-array\",\"shared/upgrade/mobile-plan-card\",\"concat\",\"eq\",\"div\",\"shared/social-set-icons\",\"svg-jar\",\"not-eq\",\"shared/ui/button\",\"fn\",\"concat-classes\",\"perform\",\"not\",\"on\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "shared/components/shared/pre-boarding/auto-trial-end/index.hbs",
    "isStrictMode": false
  });

  const desktopPlanTypes = ['starter', 'free', 'growth'];
  const mobilePlanTypes = ['starter', 'growth'];
  let ContextModalComponent = (_class = class ContextModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "onboarding", _descriptor3, this);

      _initializerDefineProperty(this, "plans", _descriptor4, this);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor5, this);

      _initializerDefineProperty(this, "segment", _descriptor6, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);

      _initializerDefineProperty(this, "userAgent", _descriptor8, this);

      _initializerDefineProperty(this, "allPlans", _descriptor9, this);

      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor10, this);

      _initializerDefineProperty(this, "selectedPlanType", _descriptor11, this);

      _defineProperty(this, "getPlans", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.subscriptions.getAllSubscriptionPlans();
          this.allPlans = this.plans.plans.filter(plan => this.planTypes.includes(plan.planType));
        }
      }), null, "getPlans", null));

      _defineProperty(this, "handleClick", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (planType) {
          if (planType !== 'free') {
            this.args.toggleAutoTrialEndModal?.();
            this.openSeamlessCheckout(planType);
          } else {
            yield this.subscriptions.markEndOfCardlessTrial(_constants.TRIAL_TYPES.autoTrial);
            this.args.toggleAutoTrialEndModal?.();
            this.segment.track('selected-plan', {
              location: 'End of TSOAS trial',
              plan_name: 'Free'
            });
            this.alerts.info(this.intl.t('plans.auto_trial.end_trial.on_free'));
          }
        }
      }), null, "handleClick", null));

      this.getPlans.perform();
    }

    get planTypes() {
      return this.userAgent.device.isMobile ? mobilePlanTypes : desktopPlanTypes;
    }

    get startTrialButtonClass() {
      return `selected--${this.selectedPlanType}`;
    }

    selectPlan(planType) {
      this.selectedPlanType = planType;
    }

    openSeamlessCheckout(planType) {
      this.seamlessCheckoutManager.openCheckoutModal(planType, {
        onCloseCheckoutModal: this.args.toggleAutoTrialEndModal
      });
    }

    toggleAllFeaturesModal(planType) {
      this.selectedPlanType = planType;
      this.showAllFeaturesModal = !this.showAllFeaturesModal;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "allPlans", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectedPlanType", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSeamlessCheckout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openSeamlessCheckout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFeaturesModal"), _class.prototype)), _class);
  _exports.default = ContextModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ContextModalComponent);
});